import { useTranslation } from 'react-i18next'
import { AppSheet } from '@/app/shell/app-sheet'
import { AvatarSprite } from '@/app/shell/avatar-sprite'
import { useCurrentUserProfile } from '@/entities/user/model/use-current-user-profile'
import { Button } from '@/shared/ui/button'

export function PersonalInfoDropdown() {
  const { currentUser } = useCurrentUserProfile()
  const { t } = useTranslation()

  const displayName =
    currentUser?.name?.trim() ||
    currentUser?.username.trim() ||
    t('shell:unknownUser')
  const fallbackInitial = displayName.trim().charAt(0).toUpperCase()

  return (
    <AppSheet
      trigger={
        <Button
          variant="ghost"
          size="icon"
          aria-label={displayName}
          className="size-10 rounded-full"
        >
          {currentUser?.avatar ? (
            <AvatarSprite
              avatar={currentUser.avatar}
              size={32}
              className="size-8 rounded-full"
            />
          ) : (
            <span
              aria-hidden="true"
              className="flex size-8 items-center justify-center rounded-full bg-muted text-sm font-semibold text-muted-foreground"
            >
              {fallbackInitial}
            </span>
          )}
        </Button>
      }
    />
  )
}
